"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  bg: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(57, 63, 70, 0.8)',
    transition: theme.transition(['opacity']),
    opacity: 0,
    overflow: 'auto',
    zIndex: 1000,
    '&.visible': {
      opacity: 1
    }
  },
  modal: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    maxHeight: '80%',
    boxSizing: 'border-box',
    borderRadius: theme.modal.borderRadius,
    backgroundColor: theme.modal.bgColor,
    boxShadow: theme.modal.boxShadow,
    border: `1px solid ${theme.modal.borderColor}`,
    transform: 'translate3d(0,-100px,0)',
    transition: theme.transition(['transform'], 400, 0),
    overflow: 'hidden',
    '&.error': {
      backgroundColor: theme.modal.errorColor
    },
    '&.visible': {
      transform: 'translate3d(0,0,0)'
    }
  },
  small: {
    width: theme.modal.small
  },
  medium: {
    width: theme.modal.medium
  },
  large: {
    width: theme.modal.large
  },
  xlarge: {
    width: theme.modal.xlarge
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.modal.headerHeight,
    boxSizing: 'border-box',
    padding: theme.modal.headerPadding,
    color: theme.modal.titleColor,
    backgroundColor: theme.modal.titleBgColor,
    borderBottom: `1px solid ${theme.modal.borderColor}`,
    position: 'relative',
    '& span': {
      maxWidth: '80%',
      wordWrap: 'break-word',
      textAlign: 'center',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      lineHeight: '22px'
    }
  },
  button: {
    cursor: 'pointer',
    position: 'absolute',
    top: 18,
    left: 20,
    color: theme.modal.cancelBtnColor,
    '&:hover': {
      color: theme.modal.cancelBtnHoverColor
    }
  },
  closeIcon: {
    position: 'absolute',
    top: 15,
    right: 15,
    cursor: 'pointer'
  }
});

exports.default = _default;